import { Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { FaEye, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { downloadBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { CollegeReport } from "../UniversityScreens/CollegeReport";
import { openScrutinyPdfInNewTab } from "../UniversityScreens/ScrutinityPdfGeneration";
import NewCollegeApplPreview from "../NewCollegeApplPreview";
import FirstLevelInspPreviewForShiftingPreview from "./FirstLevelInspPreviewForShiftingPreview";
import * as bie from "react-bootstrap";

import { Table, Row, Col, Button, Modal } from "react-bootstrap";

export default function InspectionPhysicalStatus() {
  const [physselectedRow, physSetSelectedRow] = useState(null);
  const [physicalshowShiftingModal, physicalSetShowShiftingModal] = useState(false);
  const [selectedCollCode, setSelectedCollCode] = useState(null);
  const [physicalpdfData, physicalSetPdfData1] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [selectedRowpre, setSelectedRowpre] = useState(null);
  const [pdfData2, setPdfData2] = useState({});
  const [pdfData3, setPdfData3] = useState({});
  const [showJicModal, setShowJicModal] = useState(false);
  const [ScrutinyPdfData, setScrutinyPdfData] = useState({});
  const [ScrutinyPdfData1, setScrutinyPdfData1] = useState({});
  const [showPdfModal, setShowPdfModal] = useState(false);

  const [pdfBase64, setPdfBase64] = useState("");

  let navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");


  function getShiftingScrutinyDetails(collCode, nocType) {
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          physicalSetPdfData1(res.data);
        } else {
          physicalSetPdfData1({});
        }
      })

  }
  const [getOverallData, setOverallData] = useState([]);
  function finalGetAfterSubmit(collCode) {
    let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;
        if (data && data.length > 0) {
          setPdfData2(data);
          setOverallData(res.data);
        } else {
          setOverallData([]);
        }
      })
  }

  function getShiftingAddDetails() {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res.data.data || [];

          if (shiftData.length > 0) {
            setPdfData3(res.data);
          }
        } else {
          setPdfData3('')
        }
      })
  }

  const iconBtn = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const previewBtn = {
    ...iconBtn,
    backgroundColor: "#e0f2fe",
    color: "#0284c7",
  };


  const statusBadge = {
    backgroundColor: "#dcfce7",
    color: "#15803d",
    padding: "4px 12px",
    borderRadius: "999px",
    fontSize: "12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    width: "fit-content",
    maxWidth: "100%",
    whiteSpace: "nowrap",
  };




  const EopfetchDeficiencies = async (collCode) => {
    try {
      let url = `${config.url.FAC_URL}getShiftingScrutinyDetails/${collCode}`;
      const res = await CommonAxiosGet(url);

      if (res && res.data && res.data.status === true && res.data.def) {
        if (Array.isArray(res.data.def)) {
          const mappedData = res.data.def.map((item) => {
            return {
              remarks: item.remarks || item.deficiency_description || item.deficiency,
            };
          });
          return mappedData;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error in EopfetchDeficiencies:", error);
      return [];
    }
  };

  function getInspectionPdf(collCode, nocType) {
    CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDetailspdf/${collCode}/${nocType}`)
      .then((res) => {
        const base64Pdf = res?.data?.pdf;
        if (base64Pdf) {
          downloadBase64Pdf(base64Pdf, `${collCode}_inspection_report.pdf`);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  async function openNewCollegeScrutinyPdf(row) {
    const collCode = row?.coll_code;
    if (!collCode) {
      failureAlert("College code not found. Please login again.");
      return;
    }
    const previewWindow = window.open("", "_blank");
    if (!previewWindow) {
      failureAlert("Popup blocked. Please allow popups to preview the PDF.");
      return;
    }
    previewWindow.document.write("<title>Generating PDF...</title><p style='font-family: Arial, sans-serif; padding: 24px;'>Generating scrutiny report PDF...</p>");
    try {
      const [collegeResponse, scrutinyResponse] = await Promise.all([
        CommonAxiosGet(`${config.url.FAC_URL}getCollegeDetailsById?collCode=${collCode}`),
        CommonAxiosGet(`${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`),
      ]);

      const clgDetails = collegeResponse?.data || {};
      const scrutinyData = scrutinyResponse?.data || {};

      setScrutinyPdfData(clgDetails);
      setScrutinyPdfData1(scrutinyData);
      physSetSelectedRow(row);

      await openScrutinyPdfInNewTab({ clgDetails, scrutinyData, rowData: row, previewWindow });
    } catch (error) {
      previewWindow.close();
      console.error("Failed to open scrutiny report PDF", error);
      failureAlert("Failed to generate scrutiny report PDF.");
    }
  }

  const [getSurvey, setSurvey] = useState([]);
  const getSurveyNumberr = async (collCode) => {
    let url = config.url.FAC_URL + "getlandDetailsScrutinyShitfing/" + collCode;
    try {
      const res = await CommonAxiosGet(url);
      if (res && res.data.status === true) {
        setSurvey(res.data.data[0] || res.data.data || []);
      } else {
        setSurvey([]);
      }
    } catch (err) {
      console.error("Error fetching survey number:", err);
      setSurvey([]);
    }
  };

  function getGovtStatusFile(row) {
    return row?.final_pdf_sign || "";
  }

  function hasGovtStatusFile(row) {
    const govtStatusFile = getGovtStatusFile(row);
    return govtStatusFile !== null && govtStatusFile !== undefined && String(govtStatusFile).trim() !== "";
  }

  function GetShiftingProceedings(collCode, nocType, jdstatus) {
    console.log("getProceedingsDetails called with:", { nocType, jdstatus });
    let url;
    if (jdstatus === "Deficiencies Identified") {

      url = `${config.url.FAC_URL}generateDeficiencyPdf/${collCode}/${nocType}`;
    }
    else if (nocType === "shifting" && jdstatus === "Rejected") {
      url = `${config.url.FAC_URL}shiftingRejectPdf/${collCode}/${nocType}`;
    }
    else if (nocType === "shifting") {
      url = `${config.url.FAC_URL}shiftingproceedings/${collCode}/${nocType}`;
    }


    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01" && res?.data?.pdf) {
        setPdfBase64(res.data.pdf);
        setShowPdfModal(true);
      } else {
        failureAlert("PDF not available.");
      }
    })
      .catch((err) => {
        console.error("Error fetching PDF:", err);
        failureAlert("Failed to load PDF.");
      });
  }

  function handlePost(row, index) {
    const rowValues = degreeUniFormik.values?.collegesTableData?.[index] || {};
    const govtFile = rowValues.govtFile || null;
    const isJdAdmin = userId === "jd_admin";
    const isSectionAdmin = userId === "section_admin";

    let payload;

    if (isSectionAdmin) {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        finalStatusPhysical: "Approved By CHE",
        finalPdfPhysical: row.final_pdf_sign,
        finalPdfSignPhysical: govtFile,
      };
    } else {
      payload = {
        collCode: row.coll_code || "",
        nocType: row.noc_type || "",
        inspectionStatusPhysical: row.final_status || "",
        jdStatusPhysical: rowValues.jdPhysicalStatus || "",
      };
    }
    if (isJdAdmin && !payload.jdStatusPhysical) {
      failureAlert("Please select JD Status");
      return;
    }
    // Swal({
    //   title: "Do you want to submit?",
    //   text: `Please confirm your submission for ${row.inst_name || row.coll_code}`,
    //   icon: "question",
    //   showCancelButton: true,
    //   confirmButtonText: "Yes, Submit",
    //   cancelButtonText: "Cancel",
    //   confirmButtonColor: "#3085d6",
    //   cancelButtonColor: "#d33",
    // }).then((result) => {
    //   if (result.isConfirmed) {
    const endpoint = userId === "section_admin" ? "updatesectionstatusPhysical" : "updatejdstatusPhysical";
    CommonAxiosPost(`${config.url.FAC_URL}${endpoint}`, payload)
      .then((res) => {
        if (res?.data?.ResponseCode === "01" || res?.data?.status === true) {
          successAlert2(res?.data?.ResponseDesc || "Submitted successfully");
          GetInspectionStatus();
          degreeUniFormik.setFieldValue("collegesTableData", []);
        } else {
          failureAlert(res?.data?.sdesc || "Failed to submit");
        }
      })
      .catch(() => {
        failureAlert("Something went wrong!");
      });
  }
  //   })
  // };
  const Columns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },
    {
      id: "mobile_email",
      header: "Contact Details",
      cell: ({ row }) => (
        <div style={{ textAlign: "left" }}>
          {row.original.mobile_no} <br /> {row.original.email}
        </div>
      ),
    },
    // {
    //   id: "noc_type",
    //   header: "NOC Type",
    //   accessorKey: "noc_type",
    //   meta: { style: { textAlign: "center" } },
    // },
    {
      id: "college_preview",
      header: "College Preview",
      cell: ({ row }) => {
        const clgcode = row.original;
        const nocType = row.original.noc_type?.toLowerCase();
        const isNewCollege = nocType === "new_college";
        const collCode = row.original.coll_code;
        return (
          <button
            style={previewBtn}
            title="View College"
            onClick={() => {
              if (isNewCollege) {
                setSelectedCollCode(collCode);
                setShowPreview(true);
              } else {
                navigate("/CollegeDetails", { state: { clgcode } });
              }
            }}
          >
            <FaEye />
          </button>
        );
      },
    },

    {
      id: "phase1_group",
      header: "Phase 1",
      columns: [
        {
          id: "inspection_preview",
          header: "Inspection Preview",
          cell: ({ row }) => {
            const nocType = row.original.noc_type?.toLowerCase();
            const collCode = row.original.coll_code;
            const isShifting = nocType === "shifting";
            const isEOP = nocType === "eop";
            const isNewCollege = nocType === "new_college";
            const isManagement = nocType === "management";
            const handleView = async () => {
              if (isShifting) {
                setSelectedCollCode(collCode);
                physicalSetShowShiftingModal(true);
                getShiftingScrutinyDetails(collCode, nocType);
                finalGetAfterSubmit(collCode);
                physSetSelectedRow(row.original);
                getSurveyNumberr(collCode);
                getShiftingAddDetails();
                getShiftingAddDetailsss(collCode);
              } else if (isEOP) {
                getInspectionPdf(collCode, nocType);
              } else if (isNewCollege) {
                openNewCollegeScrutinyPdf(row.original);
              } else {
                physSetSelectedRow(row.original);
              }
            };

            return (
              <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                <button
                  style={previewBtn}
                  onClick={handleView}
                  title={isShifting ? "View Shifting Scrutiny" : isEOP ? "View Inspection PDF" : isManagement ? "View Management Scrutiny" : "View Inspection"}
                >
                  <FaEye />
                </button>
              </div>
            );
          },
        },
        {
          id: "online_scrutiny",
          header: "Inspection Status",
          accessorKey: "online_scrutiny",
          cell: ({ row }) => (
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span>{row.original.online_scrutiny === "DeficiencyIdentified" ? "Deficiency Identified" : row.original.online_scrutiny}</span>
            </div>
          ),
        },
        {
          id: "online_scrutinyt",
          header: "Assign Team Details",
          accessorKey: "online_scrutinyt",
          size: 300, // or any pixel value
          cell: ({ row }) => (
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              {/* {userId === "jd_admin" && ( */}
              <span>
                {`Assigned to ${row?.original?.officer_name}-${row?.original?.cfms_id_no}`}
              </span>
              {/* )} */}
            </div>
          )
        }
      ],
    },


    {
      id: "phase12_group",
      header: "Phase 2",
      columns: [
        {
          id: "JIC Preview",
          header: "JIC Preview",
          cell: ({ row }) => (
            <button
              style={previewBtn}
              onClick={() => {
                setSelectedRowpre(row.original);
                setShowJicModal(true);
              }}
            >
              <FaEye />
            </button>
          ),
        },

        {
          id: "JIC status",
          header: userId === "section_admin" ? "JD Status / Proceedings" : "Physical Committe Remarks",
          accessorKey: userId === "section_admin" ? "jd_status" : "final_status",
          meta: { style: { textAlign: "left" } },
          cell: ({ row }) => {
            const statusText =
              userId === "section_admin"
                ? row.original.jd_status
                : row.original.final_status === "Deficiencies Identified"
                  ? "Deficiency Identified"
                  : row.original.final_status === "NoDeficienciesIdentified"
                    ? "No Deficiencies Identified"
                    : row.original.final_status === "Rejected"
                      ? "Rejected"
                      : row.original.final_status;

            return (
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div style={userId === "section_admin" ? {} : statusBadge}>
                  {userId === "jd_admin" && (
                    <>
                      <small className="text-muted">
                        {row?.original?.user_id}
                      </small>
                      <br />
                    </>
                  )}
                  {statusText} &emsp;
                  {userId === "section_admin" &&
                    <button
                      type="button"
                      style={previewBtn}
                      onClick={() => {
                        GetShiftingProceedings(
                          row.original.coll_code,
                          row.original.noc_type,
                          row.original.jd_status
                        );
                      }}
                    >
                      <FaEye />  </button>
                  }
                </div>


              </div>
            );
          },
        },
        {
          id: "committee_members",
          header: "Assigned Team Details",
          accessorKey: "committee_members",
          cell: ({ row }) => {
            const committeeData = row.original.committee_members || "";
            const teamHead = committeeData
              .split(",")
              .find((item) => item.trim().startsWith("teamHead:"));
            const teamMembers = committeeData
              .split(",")
              .filter((item) => item.trim().startsWith("teamMember:"));
            return (
              <div className="small">
                {teamHead && (
                  <div className="mb-2">
                    <span className="fw-bold text-primary">Team Head:</span>{" "}
                    {teamHead.replace("teamHead:", "").trim()}
                  </div>
                )}
                {teamMembers.length > 0 && (
                  <div>
                    <div className="fw-bold text-success mb-1">Members:</div>
                    <ul className="mb-0 ps-3">
                      {teamMembers?.map((member, index) => (
                        <li key={index}>{member.replace("teamMember:", "").trim()}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          },
        },

        {
          id: "jd_physical_status",
          header: "JD Physical Status",
          cell: ({ row }) => {
            const index = row.index;
            const jdPhysicalStatus = row.original.jd_physical_status;
            const hasSubmittedStatus = jdPhysicalStatus !== null && jdPhysicalStatus !== undefined && String(jdPhysicalStatus).trim() !== "";

            if (hasSubmittedStatus) {
              const normalizedStatus = jdPhysicalStatus;
              const statusLabel = normalizedStatus === "approved" ? "Approved" : normalizedStatus === "Deficiencies Identified" ? "Deficiencies Identified" : normalizedStatus === "Reject" ? "Rejected" : row.original.jd_physical_status;

              const statusColor = normalizedStatus === "Approved"
                ? "#15803d"
                : normalizedStatus === "Deficiencies Identified" || normalizedStatus === "Reject"
                  ? "#dc2626"
                  : "";
              return (
                <div style={{ minWidth: "180px", fontWeight: 600, color: statusColor, textAlign: "center" }}>
                  <FaCheck /> {statusLabel}
                </div>
              );
            }

            return (
              <div style={{ minWidth: "180px" }}>
                <Field as="select" name={`collegesTableData[${index}].jdPhysicalStatus`} className="form-control">
                  <option value="">--Select--</option>
                  {row?.original?.noc_type === "shifting" && userId === "section_admin" ? (
                    <>
                      <option value="Approved By CHE">Approve By CHE</option>

                      {/* <option value="Approved">APPROVED</option>
                      <option value="Rejected">REJECTED</option>
                      <option value="Conditionally Approved">CONDITIONALLY APPROVED</option> */}



                    </>
                  ) : (
                    <>
                      {/* <option value="Approved">APPROVED</option>
                      <option value="Deficiencies Identified">DEFICIENCIES IDENTIFIED</option> */}
                      <option value="Approved">APPROVED</option>
                      <option value="Conditionally Approved">CONDITIONALLY APPROVED</option>
                    </>
                  )}
                </Field>
              </div>
            );
          },
        },
        {
          id: "action",
          header: "Action",
          cell: ({ row }) => {
            const jdPhysicalStatus = row.original.jd_physical_status;
            const hasJdPhysicalStatus = jdPhysicalStatus !== null && jdPhysicalStatus !== undefined && String(jdPhysicalStatus).trim() !== "";

            if (userId === "jd_admin" && hasJdPhysicalStatus) {
              return (
                <span
                  style={{
                    color: "#15803d",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "inline-block",
                  }}
                >
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            if (userId === "section_admin" && row.original.final_status) {
              return (
                <span
                  style={{
                    color: "#15803d",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "inline-block",
                  }}
                >
                  <FaCheck /> Already Submitted
                </span>
              );
            }

            return (
              <button
                type="button"
                onClick={() => handlePost(row.original, row.index)}
                style={{
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Submit
              </button>
            );
          },
        },
      ]
    }
  ];

  if (userId === "section_admin") {
    // Add physical inspection column for section admin
    const physicalInspectionIndex = Columns.findIndex(col => col.id === "jd_physical_status");
    if (physicalInspectionIndex !== -1) {
      Columns.splice(physicalInspectionIndex, 1, {
        id: "physical_inspection",
        header: "Physical Inspection Status",
        cell: ({ row }) => {
          const index = row.index;
          const physicalInspection = row.original.final_status;
          const hasSubmittedStatus = physicalInspection !== null && physicalInspection !== undefined && String(physicalInspection).trim() !== "";

          if (hasSubmittedStatus) {
            return (
              <div style={{ minWidth: "180px", fontWeight: 600, color: "#15803d", textAlign: "center" }}>
                <FaCheck /> {physicalInspection}
              </div>
            );
          }

          return (
            <div style={{ minWidth: "180px" }}>
              <Field as="select" name={`collegesTableData[${index}].physicalInspection`} className="form-control">
                <option value="">Select</option>
                <option value="Approved By CHE">Approve By CHE</option>
                {/* <option value="Deficiencies Identified">DEFICIENCIES IDENTIFIED</option> */}
              </Field>
            </div>
          );
        },
      });
    }
  }

  const [inspstatus, setInspStatus] = useState([]);

  function GetInspectionStatus() {
    const endpoint = userId === "section_admin" ? "getsectionadmindataPhysical" : "getInspectionStatusphysical";
    CommonAxiosGet(`${config.url.FAC_URL}${endpoint}`).then((res) => {
      setInspStatus(res?.data?.scode === "01" ? res.data.data || [] : []);
      const fetchedData = res.data.data || [];
      const initialTableData = fetchedData?.map((row) => ({
        ...row,
        final_status: row.final_status || "",
        jdStatusPhysical: row.jd_status || "",
        jdPhysicalStatus: row.final_status || "",
        physicalInspection: row.physical_inspection || "",
      }));
      degreeUniFormik.setFieldValue("collegesTableData", initialTableData);
    });
  }

  const degreeUniFormik = useFormik({
    initialValues: { collegesTableData: [], nocType: "" },
    onSubmit: (values) => { },
  });

  const nocTypeOptions = Array.from(new Set((inspstatus || []).map((item) => item?.noc_type).filter((item) => item !== null && item !== undefined && String(item).trim() !== "")));

  const filteredInspectionStatus = degreeUniFormik.values.nocType
    ? inspstatus.filter((item) => String(item?.noc_type || "").toLowerCase() === String(degreeUniFormik.values.nocType).toLowerCase())
    : inspstatus;

  const nocTypeFilter = (
    <div
      style={{
        minWidth: "280px",
        maxWidth: "420px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        flexWrap: "wrap",
      }}
    >
      <label
        className="form-label mb-0"
        style={{
          color: "#0f766e",
          fontWeight: 600,
          whiteSpace: "nowrap",
          marginBottom: 0,
        }}
      >
        Select NOC Type
      </label>
      <Field
        as="select"
        name="nocType"
        className="form-control"
        onChange={degreeUniFormik.handleChange}
        style={{
          minWidth: "170px",
          maxWidth: "220px",
          borderRadius: "10px",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
        }}
      >
        <option value="">--Select--</option>
        {nocTypeOptions?.map((nocType) => (
          <option key={nocType} value={nocType}>
            {nocType}
          </option>
        ))}
      </Field>
    </div>
  );

  useEffect(() => {
    GetInspectionStatus();
  }, []);

  const [shiftAddr, setShiftAddr] = useState([]);
  function getShiftingAddDetailsss(collCode) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const shiftData = res?.data?.data || [];
          setShiftAddr(shiftData?.length > 0 && shiftData !== "No data found" ? shiftData : []);
          if (shiftData.length > 0) {
            const firstShift = shiftData[0];
            setShiftAddr({
              new_mandal: firstShift.mandal_name || firstShift.new_mandal,
              new_district: firstShift.new_dist || firstShift.new_district,
              new_pincode: firstShift.new_pincode,
              address_ofnew_location: firstShift.address_ofnew_location,
              shift_type: firstShift.shift_type,
              distance_from_existing: firstShift.distance_from_existing,
              justification: firstShift.justification,
            });
          }
        } else {
          setShiftAddr([]);
        }
      })
      .catch((err) => {
        setShiftAddr([]);
      });
  }

  return (
    <>


      <bie.Modal
        show={showPdfModal}
        onHide={() => setShowPdfModal(false)}
        size="xl"
        centered
      >
        <bie.Modal.Header closeButton>
          <bie.Modal.Title>Proceedings PDF Preview</bie.Modal.Title>
        </bie.Modal.Header>

        <bie.Modal.Body style={{ height: "80vh", padding: 0 }}>
          {pdfBase64 && (
            <iframe
              title="PDF Preview"
              src={`data:application/pdf;base64,${pdfBase64}`}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </bie.Modal.Body>

        <bie.Modal.Footer>
          {/* <button type="submit" className='btn btn-primary' onClick={dskConfirmationFunc}
          > Digi Sign

          </button> */}
        </bie.Modal.Footer>



      </bie.Modal>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        {showPreview ? (
          <NewCollegeApplPreview collCode={selectedCollCode} />
        ) : (
          <FormikProvider value={degreeUniFormik}>
            <Form onSubmit={degreeUniFormik.handleSubmit} className="affl-form">
              <bie.Row className="px-2 pt-3 mb-3 w-100">
                <h5 className="mb-3 innerheader-new">
                  <span>Physical Inspection Status</span>
                </h5>

                <bie.Col xs={12}>
                  {filteredInspectionStatus?.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <CommonReactTable
                          data={filteredInspectionStatus}
                          columns={Columns}
                          filename="AsiignInspectionToByUniversity"
                          headerName={`Physical Inspection Status -Shifting`}
                          toolbarLeftContent={nocTypeFilter}
                          showFooter={false}
                          showPagination={false}
                          showExcel={true}
                          showPrint={false}
                          excelFileName="Physical Inspection Status"
                        />
                      </div>
                    </>
                  ) : (
                    <center className="text-danger h6">*** No Data Found ***</center>
                  )}
                </bie.Col>


                <bie.Modal show={physicalshowShiftingModal} onHide={() => physicalSetShowShiftingModal(false)} size="xl" scrollable>
                  <bie.Modal.Header closeButton>
                    <bie.Modal.Title>{physselectedRow?.noc_type === "shifting" && "Shifting Scrutiny Report"}</bie.Modal.Title>
                  </bie.Modal.Header>
                  <bie.Modal.Body>
                    {physselectedRow?.noc_type === "shifting" && (
                      <CollegeReport apiData={physicalpdfData} apiData2={pdfData2} rowData={physselectedRow} getOverallData={getOverallData} getSurvey={getSurvey} newAddData={shiftAddr} />
                    )}
                  </bie.Modal.Body>
                </bie.Modal>

                <bie.Modal
                  show={showJicModal}
                  onHide={() => setShowJicModal(false)}
                  size="xl"
                  fullscreen
                >
                  <bie.Modal.Header closeButton>
                    <bie.Modal.Title>
                      Joint Inspection Committee Preview - {selectedRowpre?.coll_code}
                    </bie.Modal.Title>
                  </bie.Modal.Header>
                  <bie.Modal.Body>
                    {selectedRowpre && (
                      <FirstLevelInspPreviewForShiftingPreview
                        collCode={selectedRowpre.coll_code}
                        nocType={selectedRowpre.noc_type}
                        name="phase1"
                        type="physical"
                      />
                    )}
                  </bie.Modal.Body>
                </bie.Modal>
              </bie.Row>
            </Form>
          </FormikProvider>
        )}
      </bie.Container>
    </>
  );
}